import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
import { AdminService } from "../../services/admin.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-ffk-tv-dialog',
  templateUrl: './ffk-tv-dialog.component.html',
  styleUrls: ['./ffk-tv-dialog.component.scss']
})
export class FfkTvDialogComponent implements OnInit {
  videoForm: FormGroup;
  isEditMode = false;
  topLevelCategories: any[] = [];

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<FfkTvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEditMode = !!data.league;

    this.videoForm = this.fb.group({
      youtubeUrl: [data.videos ? data.videos.youtubeUrl : '', [Validators.required, this.youtubeUrlValidator.bind(this)]],
    });
  }

  ngOnInit(): void {
    this.adminService.getAllCategoriesWithTopLevel().subscribe((categories) => {
      this.topLevelCategories = categories;
    });
  }

  youtubeUrlValidator(control: AbstractControl): ValidationErrors | null {
    const url = control.value;
    if (!url) return null;

    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})$/;

    if (!youtubeRegex.test(url)) {
      return { invalidUrl: true };
    }

    return null;
  }

  onSave(): void {
    if (this.videoForm.valid) {
      let videoData = this.videoForm.value;

      this.adminService.addVideosUrl(videoData).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
